import React, { Component, PropTypes } from 'react';

import Splitter from '../block/splitter';
import ContentBlock from '../block/content';

import JuryEntry from './juryEntry';

export class AccountJuryOther extends Component {
	render() {
		let cases = [];

		for (var i = 0; i < this.props.allCases.length; i++) {
			if (this.props.cases.indexOf(this.props.allCases[i]) === -1) {
				cases.push(this.props.allCases[i]);
			}
		}

		return (
			<div className=''>

				<ContentBlock style={{marginTop: '1px'}}>
					<div className='account-block-content__juryhead'>
						Other projects
						<div className='account-block-content__juryhead__sub'>
							–view on desktop to vote
						</div>
					</div>
				</ContentBlock>

				{cases.map((item, i) =>
					<JuryEntry
						key={item.id}
						item={item}
						browser={this.props.browser}
						dispatch={this.props.dispatch}
						component={false} />
				)}

			</div>
		);
	}
}

export class AccountJuryMediaTitle extends Component {
	static defaultProps = {
		caseCount: 0,
	};

	render() {
		let media = (this.props.browser.window.width < 720) ? 'Mobile' : 'Tablet';
		let title = `${media} projects (${this.props.caseCount})`;

		return (
			<ContentBlock>
				<div className='account-block-content__juryhead'>
					{title}
					<div className='account-block-content__juryhead__sub'></div>
				</div>
			</ContentBlock>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/other.js
 **/